import styled from "styled-components";

export const LoginContainer = styled.div`
  display: flex;
  height: 55.3rem;
  width: min(86.3rem, 90%);

  .error-message {
    color: ${(props) => props.theme.colors.accentRed};
    font-size: 1.4rem;
    line-height: 2rem;
    margin-top: 1.9rem;
    text-align: center;
    width: 25.6rem;
  }
`;

// TODO: Check this styling later
export const TalmaInfo = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}

  border-radius: 10px 0px 0px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;

  .talmaLogo {
    height: auto;
    margin-left: 1.5rem;
    max-width: 100%;
  }
`;

export const LoginInfo = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    color: ${props.theme.colors.black};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}

  align-items: center;
  border-radius: 0px 10px 10px 0px;
  display: flex;
  flex-direction: column;
  padding-bottom: 4rem;
  width: 50%;

  p {
    font-size: 1.3rem;
    font-weight: 700;
  }

  .loginTitle {
    font-size: 2.4rem;
    font-weight: 700;
    margin-top: 9.2rem;
  }

  .emailInput {
    margin-top: 3.2rem;
  }

  .passwordInput {
    margin-bottom: 1.2rem;
    margin-top: 2.8rem;
  }

  .forgotPassword {
    cursor: pointer;
    text-align: right;
  }
`;

export const MainButton = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-top: 4.2rem;
  width: 25.6rem;

  img {
    height: 5rem;
    width: 5rem;
  }
`;

export const LoadingScreen = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.backgroundBlue};
    color: ${props.theme.colors.gray};
  `}
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 600;
  width: 100vw;

  & > img {
    height: 5rem;
    width: 5rem;
  }
`;

export const NewPasswordStep = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  .input-password {
    margin-top: 1rem;
  }

  .input-password-confirm {
    margin: 2rem 0 3rem 0;
  }
`;

interface ILoginScreen {
  img: any;
}
export const LoginScreen = styled.div<ILoginScreen>`
  ${(props) => `
    background-image: url(${props.img});
    background-size: cover;
  `}
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  width: 100wh;

  @media (max-width: 650px) {
    ${LoginContainer} {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    ${TalmaInfo}, ${LoginInfo} {
      width: 90%;
    }
    ${TalmaInfo} {
      border-radius: 10px 10px 0px 0px;
      align-items: center;
      img {
        width: 25rem;
      }
    }
    ${LoginInfo} {
      border-radius: 0px 0px 10px 10px;
      input {
        width: 27rem;
      }
    }

    .emailInput > input,
    .passwordInput > input {
      -webkit-appearance: none;
    }
  }
`;

export const LoginFooter = styled.div`
  font-size: 13px;
  position: absolute;
  bottom: 0;
  background-color: #002e6c;
  color: white;
  width: 100%;
  text-align: center;
`;
